module.exports = __webpack_public_path__ + "static/media/cases_brand_jardim_01.e9bcb257.jpg";